class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    // Close button
    this.closeButton = this.querySelector('[data-announcement-bar-close]');
    this.closeButton?.addEventListener('click', () => this.closeBar());

    // Copy code button
    this.copyCodeButton = this.querySelector('[data-announcement-bar-copy-code]');
    if (this.copyCodeButton) {
      this.copyCodeButton.addEventListener('click', () => this.copyCode());
      this.toCopyElement = this.copyCodeButton.querySelector('[data-to-copy]');
      this.copiedElement = this.copyCodeButton.querySelector('[data-is-copied]');
    }
  }

  /**
   * Remove the announcement bar from the DOM
   */
  closeBar() {
    this.closest('section')?.remove();
    this.updateCart();
  }

  /**
   * Update the cart with the closed date
   * The attribute is used to update the visibility of the bar from Liquid, avoiding CLS when using JS.
   */
  async updateCart() {
    try {
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        ...fetchConfig(),
        body: JSON.stringify({
          attributes: {
            countdown_bar_closed_on: Math.floor(Date.now() / 1000),
          },
        }),
      });
    } catch (error) {
      console.log(error);
    }
  }

  /**
   * Copy text to clipboard, show the 'Copied' text, and reverse the state after 3 seconds
   */
  async copyCode() {
    await navigator.clipboard.writeText(this.toCopyElement.textContent);

    // Clear any existing timeout to prevent multiple timers
    if (this.copyTimeout) clearTimeout(this.copyTimeout);

    // Toggle states immediately
    this.toggleCopyStates(false);

    // Set timeout to reverse the state
    this.copyTimeout = setTimeout(() => {
      this.toggleCopyStates();
    }, 3000);
  }

  /**
   * Toggle the visibility of the copied and to copy elements
   * @param {boolean} setToggle - The state to set the elements to
   */
  toggleCopyStates(setToggle = true) {
    this.copiedElement?.classList.toggle('hidden', setToggle);
    this.toCopyElement?.classList.toggle('hidden', !setToggle);
  }
}

customElements.define('announcement-bar', AnnouncementBar);
